import { memo, type CSSProperties } from 'react'
import { useShallow } from 'zustand/react/shallow'
import type { PositionReturnLuck } from '../../../store/live/live-notify'
import { useGlobalStore } from '../../../store/global-store'
import { Toast } from './components/toast'
import { useUpdateReturnValueLuck } from './use-update-return-value-luck'

// cada posição é absoluta e fixa — badges não empurram uns aos outros
const styleByPosition: Record<PositionReturnLuck, CSSProperties> = {
  top: { position: 'absolute', top: 90, left: '50%', transform: 'translateX(-50%)' },
  left: { position: 'absolute', top: 200, left: 0 },
  right: { position: 'absolute', top: 200, right: 0 },
}

export const ReturnValueLuck = memo(() => {
  useUpdateReturnValueLuck()

  const notifyGiftLuckList = useGlobalStore(
    useShallow((state) => {
      return state.notifyGiftLuckList
    }),
  )

  return (
    <div className="w-screen h-screen flex justify-center flex-row relative">
      {notifyGiftLuckList.map((toast) => (
        <div key={toast.id} style={styleByPosition[toast.position]}>
          <Toast toast={toast} position={toast.position} />
        </div>
      ))}
    </div>
  )
})
